import { Component, computed, inject, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { AlarmService } from '../_core/alarms';
import { Core } from '../_core/core';
import { IAlarm } from '../core.interface';
import { TagModule } from 'primeng/tag';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { Spinner } from '../_core/spinner';
import { AlarmsHistoric } from './alarms-historic/alarms-historic';

@Component({
  selector: 'app-alarms',
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    PaginatorModule,
    TableModule,
    TagModule,
    AlarmsHistoric,
  ],
  templateUrl: './alarms.html',
  styleUrl: './alarms.scss',
})
export class Alarms {
  public $alarms = inject(AlarmService);
  private $core = inject(Core);
  private $spinner = inject(Spinner);
  private historicDialog = viewChild(AlarmsHistoric);

  // Filtro local: Solo activas o Todas
  public onlyActive = signal<boolean>(true);
  currentPage = signal(0);

  // Computamos la lista filtrada basándonos en la señal del servicio y el filtro local
  public displayedAlarms = computed(() => {
    const alarms = this.$alarms.alarms();
    if (!this.onlyActive()) return alarms;

    const now = new Date();
    return alarms.filter((alarm) => {
      if (!alarm.expiredAt) return true;
      const expireDate = new Date(alarm.expiredAt);
      return expireDate > now;
    });
  });

  // Otros datos de interés
  // public isLoading = this.$alarms.isLoading;
  public hiddenCount = computed(() => this.$alarms.alarms().length - this.displayedAlarms().length);

  ngOnInit(): void {
    this.refreshAlarms();
  }

  async refreshAlarms() {
    const building = this.$core.selectedBuilding();
    this.$spinner.show();
    if (building?.tenantId) {
      this.currentPage.set(0);
      await this.$alarms.fetchAlarms({
        tenantId: building.tenantId,
        page: 0,
        force: true,
      });
    }

    this.$spinner.hide();
  }

  async onPageChange(event: PaginatorState) {
    const tenantId = this.$core.selectedBuilding()?.tenantId;
    if (!tenantId) return;

    const page = event.page ?? 0;
    this.currentPage.set(page);
    this.$spinner.show();
    await this.$alarms.fetchAlarms({ tenantId, page });
    this.$spinner.hide();
  }

  toggleFilter() {
    this.onlyActive.update((v) => !v);
  }

  isAlarmActive(alarm: IAlarm): boolean {
    if (!alarm.expiredAt) return true;
    return new Date(alarm.expiredAt) > new Date();
  }

  openHistoric(alarm: IAlarm): void {
    void this.historicDialog()?.open(alarm);
  }
}
